import { ApiUtil as api } from "@/utils/api.util.js";

export class GroupService {
  static URL = process.env.API_URL + process.env.API_VER;
  static RESOURCE = "/groups/";

  static all(queryParams = {}) {
    return api.get(this.URL + this.RESOURCE, queryParams).then(
      data => {
        return data;
      },
      error => {
        throw error;
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/services/group.service.js